export interface MainLayoutProps {
  hasPrimaryHeader?: boolean;
  hasPrimarySidebar?: boolean;
}

export enum IdItem {
  COMMUNITY_OUTREACH = 'community-outreach',
  GENETIC_COUNSELING = 'genetic-counseling',
  STUDY_INSIGHTS = 'study-insights',
  HRN_WITHDRAWAL = 'hrn-withdrawal',
}
